<template>
  <!-- 内容管理 -->
  <div class="useContentModule">
    <div class="noDataAvailable indexJust" style="height: 90%" v-if="dataContent">
      <loadingModule />
    </div>
    <div class="noDataAvailable indexJust" style="height: 90%" v-if="!dataContent && useList.length === 0">
      <noData />
    </div>
    <table width="100%" cellspacing="0" cellpadding="15px" v-if="!dataContent && useList.length > 0" class="useContentTableHeader">
      <tbody>
        <tr align="left" class="header">
          <td style="font-weight: bold; text-align: left" width="25%">类型</td>
          <td style="font-weight: bold; text-align: left" width="75%">内容标题</td>
        </tr>
      </tbody>
    </table>
    <div class="useContentTableBody" v-if="!dataContent && useList.length > 0">
      <table width="100%" cellspacing="0" cellpadding="15px">
        <tbody>
          <tr align="left" class="row" v-for="(item, index) in useList" :key="index">
            <td width="25%" v-if="item.msgType == 1">
              <div class="useContentYellow">市场行情</div>
            </td>
            <td width="25%" v-if="item.msgType == 2">
              <div class="useContentBlue">行业政策</div>
            </td>
            <td width="75%">{{ item.msgTitle }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { getFarmLivestockSortList } from '@/api/zzry';
import { pageNotice } from '@/api/systemManagement';
import loadingModule from '@/views/businessModule/loading1.vue';
import noData from '@/views/businessModule/noData.vue';
export default {
  props: {
    // useList: {
    //   type: Array,
    //   default: []
    // },
    useColor: {
      type: String,
      default: ''
    }
  },
  components: {
    loadingModule,
    noData
  },
  data() {
    return {
      useList: [],
      useFlag: true,
      remainderFlag: false,
      sortList: [
        {
          name: '使用率',
          click: false,
          arrow: false
        },
        {
          name: '剩余量',
          click: false,
          arrow: false
        }
      ],
      dataContent: false
    };
  },
  mounted() {
    let info = JSON.parse(localStorage.getItem('info'));
    let userInfo_ZHXM = JSON.parse(localStorage.getItem('userInfo_ZHXM'));
    let applicationType = localStorage.getItem('applicationType');
    this.dataContent = true;
    let _params = {
      openAreaLevel: info.provincialAndMunicipalLevel,
      applicationId: 16,
      applicationDeptId: 42222,
      current: 1,
      size: 10,
      isDraft: 0,
      openAreaId: 42222,
      livestockType: '1,2,3,4,5,0'
    };
    if (userInfo_ZHXM && applicationType == 2) {
      _params.applicationId = userInfo_ZHXM.applicationId;
      _params.applicationDeptId = userInfo_ZHXM.applicationDeptId;
      _params.openAreaId = userInfo_ZHXM.applicationDeptId;
    }
    pageNotice(_params)
      .then(res => {
        this.dataContent = false;
        this.useList = res.data.data.records;
      })
      .catch(err => {
        this.dataContent = false;
      });
  },
  methods: {
    totalProgress(hasBeenIssued) {
      let max = Math.max.apply(
        Math,
        this.useList.map(item => {
          return item.livestockCount;
        })
      );
      if (hasBeenIssued) {
        return (hasBeenIssued / max) * 100;
      } else {
        return 0;
      }
    }
  },
  watch: {
    // useColor(val) {
    //   this.useColor = val;
    // }
  }
};
</script>

<style lang="scss" scoped>
td {
  padding: 8px !important;
  font-size: 12px;
  color: white;
}
::-webkit-scrollbar {
  display: none;
}
.useContentModule {
  height: 100%;
  .useContentTableHeader {
    // background: linear-gradient(top, #0B1A2F, #2759A1);
    td {
      color: white;
    }
  }
  .useContentTableBody {
    height: calc(100% - 32px);
    overflow-y: auto;
    td {
      border-bottom: 1px dashed rgba(255, 255, 255, 0.5);
      .useContentYellow {
        color: #ff9a05;
        border: 1px solid #ff9a05;
        display: inline-block;
        padding: 1px 5px;
        border-radius: 2px;
      }
      .useContentBlue {
        color: #3ac0ed;
        border: 1px solid #3ac0ed;
        display: inline-block;
        padding: 1px 5px;
        border-radius: 2px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/businessModule/projectTics-yulin.vue